// extracted by mini-css-extract-plugin
export default {"clientServices":"ClientServices_clientServices__ym0-k"};